// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  name: 'local',
  relaxApiUrl: 'https://myedito-apirelax-dev.relaxnews.com/v2',
  searchApiUrl: 'https://myedito-apisearch-dev.relaxnews.com/v2',
  purpleApi: 'https://samba-dev.etx.studio/api/v1',
  baseAPI: 'https://samba-dev.etx.studio',
  dailyUpUrl: 'https://rio-dev.etx.studio',
  baseUrl: {
    purple: 'editorializer'
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
